import { useEffect, useState } from "react";
import api from "../../api/api";
import { whitecamera } from "../../utils/svgs/svgcode";
import { Backdrop, CircularProgress } from "@mui/material";
import dayjs from "dayjs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { getPracticeId } from "../../config/practice";

const ProfileCard = ({ data, img, onFileChange ,setAlertMessage,fetchuser,
  setOpen,
  setSeverity}) => {
  const {
    firstname = "",
    lastname = "",
    email = "",
    phone = "",
    username = "",
    role = "",
    status = "A",
    last_password = "",
    id,
  } = data || {};

  const [formState, setFormState] = useState({
    firstname,
    lastname,
    username,
    role,
    status,
  });
    const practiseid = getPracticeId();
const [loading,setLoading]=useState(false)
const [passwordModalOpen, setPasswordModalOpen] = useState(false);
const [oldPassword, setOldPassword] = useState("");
const [newPassword, setNewPassword] = useState("");
const [showOld, setShowOld] = useState(false);
const [showNew, setShowNew] = useState(false);

  const handleInputChange = (field, value) => {
    setFormState((prev) => ({
      ...prev,
      [field]: value,
    }));
  };
useEffect(() => {
  setFormState({
    firstname: data.firstname || "",
    lastname: data.lastname || "",
    username: data.username || "",
    role: data.role || "",
    status: data.status || "A",
  });
}, [data]);

 const handleUpdate = async () => {
  const updatedFields = {};
  
  // Normalize comparison
  if (formState.firstname.trim() !== (data.firstname || "").trim()) {
    updatedFields.firstname = formState.firstname.trim();
  }
  if (formState.lastname.trim() !== (data.lastname || "").trim()) {
    updatedFields.lastname = formState.lastname.trim();
  }
  if (formState.username.trim() !== (data.username || "").trim()) {
    updatedFields.username = formState.username.trim();
  }
  // if (formState.role.trim() !== (data.role || "").trim()) {
  //   updatedFields.role = formState.role.trim();
  // }
  // if (formState.status !== (data.status || "")) {
  //   updatedFields.status = formState.status;
  // }

  if (Object.keys(updatedFields).length === 0) {

    return;
  }


setLoading(true)
  try {
  const response=  await api.put(`/v1/${practiseid}/user`, {
      rowid: data.id,
      email:data?.email,
      ...updatedFields,
    });
    if(response.status==200){
setAlertMessage('Profile updated successfully.')
      setSeverity('success')
      setOpen(true)
      fetchuser()
    } else{
         setAlertMessage(response?.message)
      setSeverity('info')
      setOpen(true)
    }
      

  } catch (error) {
      setAlertMessage('Something Went Wrong')
      setSeverity('error')
      setOpen(true)
        console.log(error)
  }finally{
    setLoading(false)
  }
};

const changepassword = async () => {
  if (!oldPassword || !newPassword) {
    setAlertMessage("Please enter both passwords");
    setSeverity("warning");
    setOpen(true);
    return;
  }

  try {
    setLoading(true);
    const response = await api.put(`/v1/${practiseid}/user/${data.id}/password`, {
      old_password: oldPassword,
      new_password: newPassword,
    });

    if (response.status === 200) {
      setAlertMessage("Password changed successfully.");
      setSeverity("success");
      setOpen(true);
      setPasswordModalOpen(false);
      setOldPassword("");
      setNewPassword("");
    } else {
      setAlertMessage(response?.message || "Failed to update password");
      setSeverity("info");
      setOpen(true);
    }
  } catch (error) {
    setAlertMessage("Something went wrong");
    setSeverity("error");
    setOpen(true);
  } finally {
    setLoading(false);
  }
};

 
// Parse the last password date only if it exists
const lastPasswordDate = data?.last_password ? dayjs(data.last_password) : null;

// Calculate expiry only if valid
const expiryDate = lastPasswordDate ? lastPasswordDate.add(85, "day") : null;
const today = dayjs();
const daysRemaining = expiryDate ? expiryDate.diff(today, "day") : null;
  return (
    <div className="max-w-4xl text-start mx-auto mt-6 p-6 bg-white border border-gray-200 rounded-[12.75px] shadow">
      <h2 className="text-lg text-start text-[#1D2951] font-semibold mb-4">
        Profile Details
      </h2>

      <div className="flex flex-col md:flex-row items-start gap-6 p-4 border rounded bg-gradient-to-r from-[#FAF5FF] to-[#F1F5F9] shadow-inner">
        <div className="flex items-start gap-4 w-full md:w-auto">
<div className="relative w-[70px] h-[70px] rounded-[14px] border-4 border-white bg-gray-200 shadow">
  <label className="absolute inset-0 cursor-pointer">
    <img
      src={img}
      alt="Profile"
      className="object-cover  w-[70px] h-[65px] rounded-[14px]"
    />

    <input
      type="file"
      accept="image/*"
      onChange={(e) => onFileChange?.(e.target.files[0])}
      className="hidden"
    />

    <div className="absolute bottom-0 right-0 translate-x-1/2 translate-y-1/2 p-1 rounded-full bg-[#E17954] shadow">
      {whitecamera}
    </div>
  </label>
</div>

          <div className="text-start">
            <div className="font-semibold text-lg text-gray-800">
              {`${firstname} ${lastname}`}
            </div>
            <div className="text-xs text-[#6A7282]">
              User ID: <span className="text-[#e85a5a]">{username} ({id})</span>
            </div>
          <button
  onClick={() => setPasswordModalOpen(true)}
  className="text-xs text-[#3b82f6] font-medium hover:underline"
>
  Change Password
</button>

           <div className="text-xs text-[#6A7282] mt-1">
      Last Updated on - {lastPasswordDate ? lastPasswordDate.format("YYYY-MM-DD") : ""}
    </div>
    <div className="text-xs text-[#57595f]">
      {expiryDate
        ? `Password Expiry - ${expiryDate.format("YYYY-MM-DD")} (${daysRemaining} days)`
        : ""}
    </div>
          </div>
        </div>

        <div className="ml-auto mt-2 md:mt-0">
          <span
            className={`text-xs font-semibold px-3 py-1 rounded-full ${
              status === "A"
                ? "bg-[#DCFCE7] text-[#016630]"
                : "bg-red-100 text-red-700"
            }`}
          >
            {status === "A" ? "Active" : "Inactive"}
          </span>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-6">
        <div>
          <label className="block text-sm font-medium text-[#364153] mb-1">
            First Name
          </label>
          <input
            type="text"
            value={formState.firstname}
            onChange={(e) => handleInputChange("firstname", e.target.value)}
            className="w-full rounded-md border border-[#D1D5DC] bg-white p-2"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-[#364153] mb-1">
            Last Name
          </label>
          <input
            type="text"
            value={formState.lastname}
            onChange={(e) => handleInputChange("lastname", e.target.value)}
            className="w-full rounded-md border border-[#D1D5DC] bg-white p-2"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-[#364153] mb-1">
            Email
          </label>
          <input
            type="email"
            value={email}
            className="w-full rounded-md border border-[#D1D5DC] bg-[#FAF5FF] p-2"
            readOnly
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-[#364153] mb-1">
            Phone
          </label>
          <input
            type="text"
            value={phone}
            className="w-full rounded-md border border-[#D1D5DC] bg-[#FAF5FF] p-2"
            readOnly
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-[#364153] mb-1">
            Username
          </label>
          <input
            type="text"
            value={formState.username}
            onChange={(e) => handleInputChange("username", e.target.value)}
            className="w-full rounded-md border border-[#D1D5DC] bg-white p-2"
          />
        </div>

    <div>
  <label className="block text-sm font-medium text-[#364153] mb-1">
    Role
  </label>
  <input
    type="text"
    value={formState.role}
    readOnly
    className="w-full rounded-md border border-[#D1D5DC] bg-[#FAF5FF] p-2 cursor-not-allowed"
  />
</div>


     <div>
  <label className="block text-sm font-medium text-[#364153] mb-1">
    Status
  </label>
  <select
    value={formState.status}
    onChange={(e) => handleInputChange("status", e.target.value)}
    className="w-full rounded-md border border-[#D1D5DC] bg-[#FAF5FF] p-2 cursor-not-allowed"
    disabled
  >
    <option value="A">Active</option>
    <option value="I">Inactive</option>
  </select>
</div>

      </div>

      <div className="mt-6 flex w-full">
        <button
          onClick={handleUpdate}
          className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-md shadow"
        >
          Update Profile
        </button>
      </div>
      {passwordModalOpen && (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
    <div className="bg-white rounded-lg w-full max-w-sm p-6 shadow-lg relative">
      <h3 className="text-lg font-semibold text-[#1D2951] mb-4">Change Password</h3>

      <div className="flex flex-col gap-4">
        {/* Old Password */}
        <div className="relative">
          <input
            type={showOld ? "text" : "password"}
            placeholder="Old Password"
            value={oldPassword}
            onChange={(e) => setOldPassword(e.target.value)}
            className="w-full border border-gray-300 rounded-md px-3 py-2 pr-10 text-sm"
          />
          <button
            type="button"
            onClick={() => setShowOld(!showOld)}
            className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500"
          >
             {showNew ? (
       <FontAwesomeIcon icon={showOld ? faEyeSlash : faEye} className="h-4 w-4" />

            ) : (
               <FontAwesomeIcon icon={showOld ? faEyeSlash : faEye} className="h-4 w-4" />

            )}
          </button>
        </div>

        {/* New Password */}
        <div className="relative">
          <input
            type={showNew ? "text" : "password"}
            placeholder="New Password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            className="w-full border border-gray-300 rounded-md px-3 py-2 pr-10 text-sm"
          />
          <button
            type="button"
            onClick={() => setShowNew(!showNew)}
            className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500"
          >
            {showNew ? (
       <FontAwesomeIcon icon={showOld ? faEyeSlash : faEye} className="h-4 w-4" />

            ) : (
               <FontAwesomeIcon icon={showOld ? faEyeSlash : faEye} className="h-4 w-4" />

            )}
          </button>
        </div>
      </div>

      <div className="flex justify-end gap-3 mt-6">
        <button
      onClick={() => {
    setPasswordModalOpen(false);
    setOldPassword("");
    setNewPassword("");
  }}
          className="px-4 py-2 text-sm rounded bg-gray-100 hover:bg-gray-200 text-gray-700"
        >
          Cancel
        </button>
        <button
          onClick={changepassword}
          className="px-4 py-2 text-sm rounded bg-blue-600 hover:bg-blue-700 text-white"
        >
          Update
        </button>
      </div>
    </div>
  </div>
)}

        <Backdrop
                    sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 999 }}
                    open={loading}
                  >
                    <CircularProgress color="inherit" />
                  </Backdrop>
    </div>
  );
};

export default ProfileCard;
